import {Config} from "../../config";

export function apiUrl(template: TemplateStringsArray, ...args: [Config, ...unknown[]]): string {
  const config = args[0];
  const argsAny = args as unknown[];
  argsAny[0] = `${config.endpoints.api}/api/finder/${SessionIdRouteParam}`;
  return String.raw(template, ...argsAny);
}

export const SessionIdRouteParam = ':sessionId';
export const AppointmentIdRouteParam = ':appointmentId';
